import type { StaffRole } from '@ucp/web/lib';

/**
 * Every role holding an `er_meeting_compliance_run` or `er_checklist_manage` capability
 * (PRO-1290 Epic 1, ADR-068 / ADR-018). Mirrors the server role→capability map;
 * `L6_PLATFORM_ADMIN` is DELIBERATELY absent (EoP — never an HR shortcut).
 *
 * Kept separate from `HR_INTERVIEW_COMPLIANCE_ROLES` rather than merged into it: the two
 * surfaces share a route base but not an audience, and a shared array would make an ER role
 * silently confer nav visibility for the recruitment tabs. `AppRoutes` guards the shared
 * surface on the UNION of the two; the tabs and routes inside it are per-role.
 *
 * Dependency-light for the same reason as `interviewComplianceRoles.ts` — the route guard
 * needs it synchronously without dragging the lazy-loaded surface into the initial chunk.
 */
export const HR_ER_MEETING_ROLES: readonly StaffRole[] = [
  'HR_CASE_MANAGER',
  'HR_EMPLOYEE_RELATIONS_LEAD',
];
